console.log('POPUP.JS LOADED vTEST', Date.now());

class DialogComponent extends HTMLElement {
  constructor() {
    super();

    this.dialogButton = null;
    this.dialogModal = null;
    this.closeButton = null;

    this._ignoreBackdropUntil = 0;
    this._pressed = false;

    this._onPointerDown = null;
    this._onPointerUp = null;
    this._onClick = null;
    this._onCloseClick = null;
    this._onDialogClick = null;
    this._onDialogClose = null;
    this._onResize = null;
  }

  connectedCallback() {
    this.dialogButton = this.querySelector('[data-ref="popup-toggle"]');
    this.dialogModal = this.querySelector('[data-ref="popup-modal"]');
    this.closeButton = this.querySelector('[data-ref="popup-close"]');

    if (!this.dialogModal) return;

    // Bind une seule fois
    this._onPointerDown = this.#handlePointerDown.bind(this);
    this._onPointerUp = this.#handlePointerUp.bind(this);

    // On neutralise le click pour éviter double toggle Android
    this._onClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
      return false;
    };

    this._onCloseClick = this.#closeModal.bind(this);
    this._onDialogClick = this.#onBackdropClick.bind(this);
    this._onDialogClose = this.#onClose.bind(this);
    this._onResize = this.#handleResize.bind(this);

    // Ouverture via pointer (pas click)
    this.dialogButton?.addEventListener('pointerdown', this._onPointerDown, { passive: false });
    this.dialogButton?.addEventListener('pointerup', this._onPointerUp, { passive: false });
    this.dialogButton?.addEventListener('click', this._onClick, true);

    this.closeButton?.addEventListener('click', this._onCloseClick);

    this.dialogModal.addEventListener('click', this._onDialogClick);
    this.dialogModal.addEventListener('close', this._onDialogClose);

    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    this.dialogButton?.removeEventListener('pointerdown', this._onPointerDown);
    this.dialogButton?.removeEventListener('pointerup', this._onPointerUp);
    this.dialogButton?.removeEventListener('click', this._onClick, true);

    this.closeButton?.removeEventListener('click', this._onCloseClick);

    this.dialogModal?.removeEventListener('click', this._onDialogClick);
    this.dialogModal?.removeEventListener('close', this._onDialogClose);

    window.removeEventListener('resize', this._onResize);
  }

  /* ===============================
     OPEN LOGIC
  =============================== */

  #handlePointerDown(e) {
    this._pressed = true;

    e.preventDefault();
    e.stopPropagation();

    try {
      if (this.dialogButton?.setPointerCapture && e.pointerId != null) {
        this.dialogButton.setPointerCapture(e.pointerId);
      }
    } catch (_) {}
  }

  #handlePointerUp(e) {
    if (!this._pressed) return;
    this._pressed = false;

    e.preventDefault();
    e.stopPropagation();

    this.#showModal();
  }

  #showModal() {
    // Ignore backdrop clicks pendant 600ms (fix Android release bug)
    this._ignoreBackdropUntil = performance.now() + 600;

    if (!this.dialogModal.open) {
      this.dialogModal.showModal();
    }

    this.dialogModal.scrollTop = 0;
    document.body.classList.add('overflow-hidden');

    // Focus input
    const input = this.dialogModal.querySelector(
      'input[type="search"], input[name="q"], input'
    );

    if (input) {
      setTimeout(() => input.focus({ preventScroll: true }), 0);
      setTimeout(() => input.focus({ preventScroll: true }), 150);
    }
  }

  /* ===============================
     CLOSE LOGIC
  =============================== */

  #closeModal(event) {
    if (event) event.preventDefault();

    if (!this.dialogModal.open) return;

    this.dialogModal.close();
  }

  #onClose() {
    document.body.classList.remove('overflow-hidden');
  }

  /* ===============================
     BACKDROP CLICK (FIXED)
  =============================== */

  #onBackdropClick(event) {
    // Ignore faux clic Android juste après ouverture
    if (performance.now() < this._ignoreBackdropUntil) return;

    // Ferme uniquement si clic DIRECT sur le backdrop
    if (event.target === this.dialogModal) {
      this.#closeModal();
    }
  }

  #handleResize() {
    if (this.dialogModal.open) {
      this.#closeModal();
    }
  }

  /* ===============================
     PUBLIC API
  =============================== */

  open() {
    this.#showModal();
  }

  close() {
    this.#closeModal();
  }

  get isOpen() {
    return this.dialogModal ? this.dialogModal.open : false;
  }
}

if (!customElements.get('dialog-component')) {
  customElements.define('dialog-component', DialogComponent);
}